import { PropsWithChildren } from 'react';

import { Grid, Typography } from '@mui/material';

interface SectionHeaderProps {
  title: string;
}

function SectionHeader({ children, title }: PropsWithChildren<SectionHeaderProps>) {
  return (
    <Grid container direction="row" justifyContent="space-between" sx={{ backgroundColor: 'lightGray', p: 2 }}>
      <Grid item>
        <Typography sx={{ fontWeight: '700', fontSize: '20px' }}>{title}</Typography>
      </Grid>
      <Grid item>{children}</Grid>
    </Grid>
  );
}

export default SectionHeader;
